// extracted by mini-css-extract-plugin
export default {"neonButton":"dQZZxXoO","_disabled":"Y9wwSqho","borders":"_mYR94l_","content":"Z99INwyp"};